const _storage = localStorage;

export default {

    /**
     * Get booking period start date for the booking page from storage.
     */
    getBookingBookingStartDateFromStorage() {
        return _storage.getItem('bookingBookingStartDate');
    },

    /**
     * Get booking period end date for the booking page from storage.
     */
    getBookingBookingEndDateFromStorage() {
        return _storage.getItem('bookingBookingEndDate');
    },

    /**
     * Set booking period for the booking page in storage
     *
     * @param bookingPeriod
     */
    setBookingBookingPeriodInStorage(bookingPeriod) {
        _storage.setItem('bookingBookingStartDate', bookingPeriod.from);
        _storage.setItem('bookingBookingEndDate', bookingPeriod.to);
    },

    /**
     * Get arrival period start date for the booking page from storage.
     */
    getBookingArrivalStartDateFromStorage() {
        return _storage.getItem('bookingArrivalStartDate');
    },

    /**
     * Get arrival period end date for the booking page from storage
     */
    getBookingArrivalEndDateFromStorage() {
        return _storage.getItem('bookingArrivalEndDate');
    },

    /**
     * Set arrival period for the booking page in storage
     *
     * @param arrivalPeriod
     */
    setBookingArrivalPeriodInStorage(arrivalPeriod) {
        _storage.setItem('bookingArrivalStartDate', arrivalPeriod.from);
        _storage.setItem('bookingArrivalEndDate', arrivalPeriod.to);
    },
}



// WEBPACK FOOTER //
// ./src/services/DateStorageService.js